import { em, rem } from 'polished'
import styled from 'styled-components'

export const BaseStepCountStyled = styled.div`
  font-size: ${rem(16)};
`
